import React from "react";
import SvgIcon from "e100-react-components/lib/components/SvgIcon";
import { IProps } from "e100-react-components/lib/components/SvgIcon/index";

const Axles = (props: IProps) => (
  <SvgIcon {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.66536 5C1.20513 5 0.832031 5.3731 0.832031 5.83333L0.832031 14.1667C0.832031 14.6269 1.20513 15 1.66536 15H3.33203C3.79227 15 4.16536 14.6269 4.16536 14.1667L4.16536 10.8333H7.64095C7.98415 11.8043 8.91018 12.5 9.9987 12.5C11.0872 12.5 12.0132 11.8043 12.3564 10.8333L15.832 10.8333V14.1667C15.832 14.6269 16.2051 15 16.6654 15L18.332 15C18.7923 15 19.1654 14.6269 19.1654 14.1667V5.83333C19.1654 5.3731 18.7923 5 18.332 5H16.6654C16.2051 5 15.832 5.3731 15.832 5.83333V9.16667L12.3564 9.16667C12.0132 8.19567 11.0872 7.5 9.9987 7.5C8.91018 7.5 7.98415 8.19567 7.64095 9.16667H4.16536L4.16536 5.83333C4.16536 5.3731 3.79227 5 3.33203 5H1.66536Z"
      fill="#515B69"
    />
  </SvgIcon>
);

export default Axles;
